import React, { useContext, useEffect } from "react";


import EventBusyIcon from "@mui/icons-material/EventBusy";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import VerifiedIcon from "@mui/icons-material/Verified";
import EditIcon from '@mui/icons-material/Edit';

import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    Divider,
    Grid,
    IconButton,
    Link,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip,
    Typography
} from "@mui/material";



import DeleteIcon from "@mui/icons-material/Delete";

import { stringToLocaleDateString } from "../../../../helpers";
import { UtenteLink } from "../../../common";
import { NavContext, NavRoutes } from "../../../contexts";
import { UfficiContext } from "../UfficiContext";
import { TipiUfficiFilter } from "./TipiUfficiFilter";
import FileCopyIcon from '@mui/icons-material/FileCopy';

export const UfficiList = ({
    notConvalidatedFilter,
    setNotConvalidatedFilter,

    validFilter,
    setValidFilter,

    notValidFilter,
    setNotValidFilter,

    pageIndex,
    setPageIndex,

    pageSize,
    setPageSize,

    searchText,

    itemsPerPage,
    disabled,
    onLoadMore,
    onActionClick,
    ...props
}) => {
    const { getRouteTo, navigateTo } = useContext(NavContext);

    const { state } = useContext(UfficiContext);

    const {
        tipiUfficiFilter,
        uffici
    } = state;

    const pageIndexChangeHandler = (e, index) => {
        setPageIndex(index);
    };

    const deleteClickHandler = async (data) => {
        if (onActionClick) onActionClick("Delete", data);
    };

    const editClickHandler = async (data) => {
        if (onActionClick) onActionClick("Edit", data);
    };

    const cloneClickHandler = async (data) => {
        if (onActionClick) onActionClick("Clone", data);
    };

    const addClickHandler = (data) => {
        if (onActionClick) onActionClick("Add", data);
    };

    const wizardClickHandler = (data) => {
        if (onActionClick) onActionClick("Wizard", data);
    };

    const pageSizeChangeHandler = (e) => {
        setPageSize(e.target.value);
    };

    useEffect(() => {
        if (uffici && onLoadMore) {
            onLoadMore(
                pageIndex,
                pageSize,
                searchText,
                notConvalidatedFilter,
                validFilter,
                notValidFilter,
                tipiUfficiFilter,
            );
        }
    }, [pageIndex, pageSize]);

    useEffect(() => {
        if (uffici && onLoadMore) {
            setPageIndex(0)
            onLoadMore(
                0,
                pageSize,
                searchText,
                notConvalidatedFilter,
                validFilter,
                notValidFilter,
                tipiUfficiFilter,
            );
        }
    }, [searchText, notConvalidatedFilter, validFilter, notValidFilter, tipiUfficiFilter]);

    return (
        <div style={{ display: 'relative' }}>
            <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                sx={{ marginTop: 3 }}
            >
                {uffici ? uffici.totalCount : 0}&nbsp;Record trovati
            </Typography>
            <Card >
                <CardHeader
                    titleTypographyProps={{ variant: "h6" }}
                    title={
                        <Grid container justifyContent="space-between">
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <Typography variant="h6">Tutti gli Uffici</Typography>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        color: "white !important",
                                    }}
                                >
                                    <TipiUfficiFilter />
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Checkbox
                                                onChange={(e) => {
                                                    setNotConvalidatedFilter(!notConvalidatedFilter);
                                                }}
                                                checked={notConvalidatedFilter}
                                                sx={{ color: "white" }}
                                            />
                                            <Typography variant="caption">NON CONVALIDATI</Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Checkbox
                                                onChange={(e) => {
                                                    setValidFilter(!validFilter);
                                                }}
                                                checked={validFilter}
                                                sx={{ color: "white" }}
                                            />
                                            <Typography variant="caption">ATTIVI</Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Checkbox
                                                onChange={(e) => {
                                                    setNotValidFilter(!notValidFilter);
                                                }}
                                                checked={notValidFilter}
                                                sx={{ color: "white" }}
                                            />
                                            <Typography variant="caption">NON ATTIVI</Typography>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    disableElevation
                                    color="info"
                                    disabled={disabled}
                                    onClick={wizardClickHandler}
                                    sx={{ mr: 2 }}
                                >
                                    Wizard
                                </Button>
                                <Button
                                    variant="contained"
                                    disableElevation
                                    color="info"
                                    disabled={disabled}
                                    onClick={addClickHandler}
                                >
                                    Aggiungi
                                </Button>
                            </Grid>
                        </Grid>
                    }
                    sx={{ backgroundColor: "secondary.main", color: "white" }}
                />
                <Divider />
                <CardContent sx={{ padding: 0 }}>
                    <Table>
                        <TableHead sx={{ backgroundColor: "aliceblue" }}>
                            <TableRow>
                                <TableCell style={{ width: "50%" }}>Nome</TableCell>
                                {/* <TableCell style={{ width: "30%" }}>Indirizzo</TableCell> */}
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Inserito da
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Modificato da
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data inserimento
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data Modifica
                                </TableCell>
                                <TableCell align="right" style={{ width: "10%" }}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {uffici && uffici.result.length > 0 ? (
                                uffici.result.map((ufficio, index) => {
                                    return (
                                        <TableRow hover key={index}>
                                            <TableCell>
                                                <div
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div>
                                                        <Link
                                                            color="textPrimary"
                                                            onClick={() => window.open(getRouteTo(NavRoutes.Ufficio, [ufficio.id]) + "?solaLettura=true", "_blank").focus()}
                                                            sx={{ fontWeight: 700, cursor: "pointer" }}
                                                        >
                                                            {ufficio.nome}
                                                            {ufficio?.convalidato ? (
                                                                <VerifiedIcon color="success" />
                                                            ) : (
                                                                <NewReleasesIcon color="warning" />
                                                            )}
                                                            {[
                                                                ufficio.comune?.provincia?.regione
                                                                    ?.fineValidita,
                                                                ufficio.comune?.provincia?.fineValidita,
                                                                ufficio.comune?.dataCessazione,
                                                                ufficio.fineValidita,
                                                            ].some((x) => x && x <= new Date()) && (
                                                                    <EventBusyIcon
                                                                        color={
                                                                            ufficio.fineValidita &&
                                                                                ufficio.fineValidita <= new Date()
                                                                                ? "error"
                                                                                : "warning"
                                                                        }
                                                                    />
                                                                )}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            {/* <TableCell>
                                                <div
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div>{ufficio.indirizzo} - {ufficio.cap} - {ufficio.comune?.denominazioneIt} - {ufficio.comune?.provincia.sigla}</div>
                                                </div>
                                            </TableCell> */}
                                            <TableCell align="center">
                                                <UtenteLink utenteId={ufficio?.creatoDa} />
                                            </TableCell>
                                            <TableCell align="center">
                                                <UtenteLink utenteId={ufficio?.aggiornatoDa} />
                                            </TableCell>
                                            <TableCell align="center">
                                                {stringToLocaleDateString(ufficio.dataCreazione)}
                                            </TableCell>
                                            <TableCell align="center">
                                                {stringToLocaleDateString(ufficio.dataAggiornamento)}
                                            </TableCell>
                                            <TableCell align="right">
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                    <IconButton
                                                        aria-label="modifica"
                                                        disabled={disabled}
                                                        onClick={() => editClickHandler(ufficio, ufficio)}
                                                    >
                                                        <Tooltip title="modifica" placement="top">
                                                            <EditIcon />
                                                        </Tooltip>
                                                    </IconButton>
                                                    <IconButton
                                                        aria-label="clone"
                                                        disabled={disabled}
                                                        onClick={() => cloneClickHandler(ufficio)}
                                                    >
                                                        <Tooltip title="clona ufficio" placement="top">
                                                            <FileCopyIcon />
                                                        </Tooltip>
                                                    </IconButton>
                                                    <IconButton
                                                        aria-label="delete"
                                                        disabled={disabled}
                                                        onClick={() => deleteClickHandler(ufficio)}
                                                    >
                                                        <Tooltip title="elimina ufficio" placement="top">
                                                            <DeleteIcon />
                                                        </Tooltip>
                                                    </IconButton>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            ) : (
                                <TableRow>
                                    <TableCell
                                        align="center"
                                        colSpan="100%"
                                        sx={{
                                            padding: 8,
                                            color: "primary.main",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        NON SONO PRESENTI UFFICI
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </CardContent>
                <TablePagination
                    component="div"
                    count={uffici ? uffici.totalCount : 0}
                    onPageChange={pageIndexChangeHandler}
                    onRowsPerPageChange={pageSizeChangeHandler}
                    page={pageIndex}
                    rowsPerPage={pageSize}
                    rowsPerPageOptions={[5, 10, 25]}
                />
            </Card>
        </div>
    );
};
